import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  path?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="py-4">
      <ol className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
        {items.map((item, index) => (
          <li key={`${item.label}-${index}`} className="flex items-center gap-2">
            {item.path ? (
              <Link to={item.path} className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 whitespace-nowrap">{item.label}</span>
            )}
            {index < items.length - 1 ? (
              <span className="w-3 h-3 flex items-center justify-center text-foreground-300">
                <i className="ri-arrow-right-s-line"></i>
              </span>
            ) : null}
          </li>
        ))}
      </ol>
    </nav>
  );
}